export const defaultPageModel = { page: 0, pageSize: 15 };
export const defaultFilterModel = { field: "", value: "", operator: "" };
export const pageSizeOptions = [10, 15, 25, 50, 100];
